import { service } from "@server/client";
import type {
  UpdateCartMutation,
  UpdateCartMutationVariables,
} from "@server/gql/graphql";
import { updateCartMutation } from "@server/queries/cart";

export const updateCart = async (variables: UpdateCartMutationVariables) => {
  try {
    const response = await service<
      UpdateCartMutation,
      UpdateCartMutationVariables
    >({
      query: updateCartMutation,
      variables,
    });

    return response.cart;
  } catch (error: Error | unknown) {
    console.error("Error in updateCart", error);
    throw error;
  }
};
